import {
  Datagrid,
  DateField,
  FunctionField,
  List,
  ListActions,
  ReferenceField,
  ReferenceInput,
  SelectField,
  SelectInput,
  SimpleList,
  TextField,
  TextInput,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import permissions from "app/permissions";
import { settings } from "app";
import { getPermissions } from "auth/security/securityUtils";
import { MobileListRow } from "features/MobileListRow";
import { checkPermission } from "server/security/utils";
import { DormitoryAccommodationOrderStatusChoices } from "utils/choices";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { dormitoryRequests } from "api/dormitoryApi";
import AccommodationOrderActions from "./Actions";
import DormitoryAutocompleteInput from "../Partials/DormitoryAutocompleteInput";
import DatagridActions from "../Partials/DatagridActions";

const renderRoom = record => `${record?.residentialNumber || "—"}-${record?.roomNumber || "—"}`;

const listFilters = [
  <ReferenceInput
    key="accommodationId"
    source="accommodationId"
    reference={dormitoryRequests.getAccommodationsSelect()}
    alwaysOn
  >
    <DormitoryAutocompleteInput
      label="Настаняване"
      emptyText="Всички"
    />
  </ReferenceInput>,
  <TextInput source="number" label="Номер" alwaysOn />,
  <SelectInput
    source="status"
    label="Статус"
    choices={DormitoryAccommodationOrderStatusChoices}
    alwaysOn
    emptyText="Всички"
  />,
];

const ListAccommodationOrders = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Настанителни заповеди"
      exporter={false}
      filters={listFilters}
      actions={
        <ListActions
          hasCreate={checkPermission(getPermissions(), permissions.canManageDormitoryAccommodationOrders)}
        />
      }
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Номер", value: record?.number }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Настаняване",
                    value: (
                      <ReferenceField
                        source="accommodationId"
                        reference={dormitoryRequests.getAccommodationsSelect()}
                        link={false}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow fields={[{ label: "Стая", value: renderRoom(record) }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Дата на създаване",
                    value: <DateField source="createdOn" locales="bg-BG" />,
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value: <SelectField source="status" choices={DormitoryAccommodationOrderStatusChoices} />,
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => <AccommodationOrderActions mobile />}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField source="number" label="Номер" sortable={false} />
          <ReferenceField
            source="accommodationId"
            reference={dormitoryRequests.getAccommodationsSelect()}
            label="Настаняване"
            link={false}
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <FunctionField
            source="room"
            label="Стая"
            render={renderRoom}
            sortable={false}
          />
          <DateField
            source="createdOn"
            label="Дата на създаване"
            locales="bg-BG"
            sortable={false}
          />
          <SelectField
            source="status"
            label="Статус"
            choices={DormitoryAccommodationOrderStatusChoices}
            sortable={false}
          />
          <FunctionField
            source="actions"
            label={false}
            sortable={false}
            render={() => (
              <DatagridActions>
                <AccommodationOrderActions />
              </DatagridActions>
            )}
          />
        </Datagrid>
      )}
    </List>
  );
};

export default ListAccommodationOrders;
